import React from 'react';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers/type';
import WkblScriptVO from 'commons/vo/WkblScriptVO';
import { WkblScript } from 'components/ScriptThumbnailView';
import useStorage from 'hooks/useStorage';

function WkblScriptThumbnailView() {
  const { wkblScriptList } = useSelector((state: RootState) => state.wkblScript);
  const { getStorage } = useStorage();

  return (
    <Grid container spacing={2}>
      {wkblScriptList.map((wkblScript: WkblScriptVO, index: number) => {
        const storage = getStorage(wkblScript.categoryId);
        wkblScript.symbolicPath = storage?.symbolicPath;

        return <WkblScript key={`${wkblScript.id}_${index}`} script={wkblScript} />;
      })}
    </Grid>
  );
}

export default WkblScriptThumbnailView;
